export const interactionSearchData = {
  hits: 57281,
  data: [
    {
      id: '201251645350',
      threadId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
      threadIdOnExternalPlatform:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
      channelId: 'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee',
      interactionId: '2e73596c-274b-4667-ad8a-7b18e7a19cce',
      consumerContactStorageId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
      contactId: '3f581f5e-dfa3-4f5b-ba4d-b309079adedd',
      customerContactId: '403181ae-162f-4007-ab52-5bc7fe8cf101',
      status: 'new',
      author: 'Facebook',
      statusUpdatedAt: '2024-05-16T23:42:37+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:42:37.000+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      skill: 'KK-Chat-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: '2024-05-17T07:48:32+00:00',
      inboxAssigneeUser: 'Kalby Awadkansee',
      // ownerAssigneeUser: {
      //   id: 14194,
      //   incontactId: '11ed2ded-c1c2-9f90-bf3a-0242ac110002',
      //   agentId: 1544935,
      //   emailAddress: 'vaibhav.khandekar@nice.com',
      //   loginUsername: 'agent01.cxiaintegrategbu@so0032.com',
      //   firstName: 'agent01',
      //   surname: 'CXIAIntegrateGBU',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/a.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/a.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Kalby Awadkansee',
      inboxPreAssigneeUser: null,
      ownerAssignee: 14194,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
          name: 'Liam Davis',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609/case/201251645350',
      authorEndUserIdentity: {
        idOnExternalPlatform: '94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
        firstName: 'Liam',
        lastName: 'Davis',
        nickname: 'Liam Davis',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'chat',
        id: 'chat_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
        fullName: 'Liam Davis',
      },
      direction: 'outbound',
      createdAt: new Date().toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'chat_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
        updatedAt: new Date().toISOString(),
        firstName: 'Liam',
        surname: 'Davis',
        fullName: 'Liam Davis',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
            firstName: 'Liam',
            lastName: 'Davis',
            nickname: 'Liam Davis',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'chat',
            id: 'chat_94ffc84a-e1ff-d6ca-c7b4-7afa8e787609',
          },
        ],
        messageStatistics: {
          inbound: 2,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 2,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 54727,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 54727,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 10000,
          isRunning: true,
          alreadyHasValue: false,
        },
      },
      preview: 'LOAD TEST MESSAGE94ffc84a-e1ff-d6ca-c7b4...',
      isOutboundAllowed: true,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645349',
      threadId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
      threadIdOnExternalPlatform:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
      channelId: 'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee',
      interactionId: '241c5988-a57b-49ad-be5b-ca7419b9254d',
      consumerContactStorageId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
      contactId: 'e71de9f8-ecf3-4234-843b-615d20b25e15',
      customerContactId: '346d169f-874f-43a3-9e62-2a6ccd19eb5f',
      status: 'new',
      statusUpdatedAt: '2024-05-16T23:40:59+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:40:59.000+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'KK-Chat-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: '2024-05-17T07:23:36+00:00',
      inboxAssigneeUser: 'John Smithson',
      // ownerAssigneeUser: {
      //   id: 14194,
      //   incontactId: '11ed2ded-c1c2-9f90-bf3a-0242ac110002',
      //   agentId: 1544935,
      //   emailAddress: 'vaibhav.khandekar@nice.com',
      //   loginUsername: 'agent01.cxiaintegrategbu@so0032.com',
      //   firstName: 'agent01',
      //   surname: 'CXIAIntegrateGBU',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/a.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/a.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'John Smithson',
      inboxPreAssigneeUser: null,
      ownerAssignee: 14194,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: 'd5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
          name: 'Amara Kapadia',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da/case/201251645349',
      authorEndUserIdentity: {
        idOnExternalPlatform: 'd5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
        firstName: 'Amara',
        lastName: 'Kapadia',
        nickname: 'Amara Kapadia',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'chat',
        id: 'chat_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
        fullName: 'Amara Kapadia',
      },
      direction: 'inbound',
      createdAt: new Date().toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'chat_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
        updatedAt: new Date().toISOString(),
        firstName: 'Amara',
        surname: 'Kapadia',
        fullName: 'Amara Kapadia',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: 'd5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
            firstName: 'Amara',
            lastName: 'Kapadia',
            nickname: 'Amara Kapadia',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'chat',
            id: 'chat_d5a1dd9f-1334-7788-2cc8-ce4fa46a13da',
          },
        ],
        messageStatistics: {
          inbound: 2,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 2,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 54825,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 54825,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 10000,
          isRunning: true,
          alreadyHasValue: false,
        },
      },
      preview: 'LOAD TEST MESSAGEd5a1dd9f-1334-7788-2cc8...',
      isOutboundAllowed: true,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645348',
      threadId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
      threadIdOnExternalPlatform:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
      channelId: 'email_8dadcab8-4d4b-4d8e-bd85-acba515bfcee',
      interactionId: '81f4a3a6-f2dd-4ed3-8f4a-1d7c886fd0e0',
      consumerContactStorageId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
      contactId: '8d6bdbe1-5604-41a4-bf44-f12eb517a851',
      customerContactId: 'ad2c663b-3cd1-4fa9-87a8-36fe187b15ae',
      status: 'new',
      statusUpdatedAt: '2024-05-16T23:39:21+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:39:21.000+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'KK-Email-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: '2024-05-16T23:39:23+00:00',
      inboxAssigneeUser: 'John Smithson',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'John Smithson',
      inboxPreAssigneeUser: null,
      ownerAssignee: 36858,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: 'a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
          name: 'Amara Kapadia',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a/case/201251645348',
      authorEndUserIdentity: {
        idOnExternalPlatform: 'a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
        firstName: 'Amara',
        lastName: 'Kapadia',
        nickname: 'Amara Kapadia',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'chat',
        id: 'chat_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
        fullName: 'Amara Kapadia',
      },
      direction: 'inbound',
      createdAt: new Date(Date.now() - 86400000).toISOString().split('T')[0],
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'chat_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
        updatedAt: new Date(Date.now() - 86400000).toISOString().split('T')[0],
        firstName: 'Amara',
        surname: 'Kapadia',
        fullName: 'Amara Kapadia',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: 'a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
            firstName: 'Amara',
            lastName: 'Kapadia',
            nickname: 'Amara Kapadia',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'chat',
            id: 'chat_a8e8c4ba-9707-e1ae-3148-8d88ee010c0a',
          },
        ],
        messageStatistics: {
          inbound: 2,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 2,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 54924,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 54924,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 10000,
          isRunning: true,
          alreadyHasValue: false,
        },
      },
      preview: 'LOAD TEST MESSAGEa8e8c4ba-9707-e1ae-3148...',
      isOutboundAllowed: true,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645347',
      threadId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
      threadIdOnExternalPlatform:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
      channelId: 'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee',
      interactionId: 'e9316c42-f678-4d09-b50b-57d5eac3fe7a',
      consumerContactStorageId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
      contactId: '215dfc67-d0af-4635-ae89-88606e31d42c',
      customerContactId: 'a9c98a9e-122b-4d80-8c05-ecf3b49a1d6c',
      status: 'new',
      statusUpdatedAt: '2024-05-16T23:37:42+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:37:42.000+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'KK-Chat-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: '2024-05-16T23:37:43+00:00',
      inboxAssigneeUser: 'Janwdye Shealty',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: 36858,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
          name: 'Liam Davis',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_969f5f65-6014-c18c-474b-2f4ac3c8ae6e/case/201251645347',
      authorEndUserIdentity: {
        idOnExternalPlatform: '969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
        firstName: 'Liam',
        lastName: 'Davis',
        nickname: 'Liam Davis',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'chat',
        id: 'chat_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
        fullName: 'Liam Davis',
      },
      direction: 'inbound',
      createdAt: new Date(Date.now() - 86400000).toISOString().split('T')[0],
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'chat_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
        updatedAt: new Date(Date.now() - 86400000).toISOString().split('T')[0],
        firstName: 'Liam',
        surname: 'Davis',
        fullName: 'Liam Davis',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
            firstName: 'Liam',
            lastName: 'Davis',
            nickname: 'Liam Davis',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'chat',
            id: 'chat_969f5f65-6014-c18c-474b-2f4ac3c8ae6e',
          },
        ],
        messageStatistics: {
          inbound: 2,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 2,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 55023,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 55023,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 10000,
          isRunning: true,
          alreadyHasValue: false,
        },
      },
      preview: 'LOAD TEST MESSAGE969f5f65-6014-c18c-474b...',
      isOutboundAllowed: true,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645346',
      threadId: 'voice_8017155048_247f2e77-aeb1-4d3b-8ff8-795ec115b1c9',
      threadIdOnExternalPlatform: '201331660241',
      channelId: 'voice_8017155048',
      interactionId: '1c937710-6d37-44af-8873-81b0fc6f417b',
      consumerContactStorageId:
        'voice_8017155048_247f2e77-aeb1-4d3b-8ff8-795ec115b1c9',
      contactId: '8bbb1445-692c-48d0-885b-8ebaaf8fb469',
      customerContactId: 'f4f4eb14-3fcb-435a-ad9a-b3566192069a',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:37:22+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:37:22.652+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_247f2e77-aeb1-4d3b-8ff8-795ec115b1c9/case/201251645346',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35317,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645345',
      threadId: 'voice_8017155048_590b2027-468b-42bd-b817-d8d6e201fe42',
      threadIdOnExternalPlatform: '201331660219',
      channelId: 'email_8017155048',
      interactionId: 'a8764933-828d-4fd1-a2f9-1624b81cf134',
      consumerContactStorageId:
        'voice_8017155048_590b2027-468b-42bd-b817-d8d6e201fe42',
      contactId: '52a26805-1b49-4325-91ca-77090ab2d5ba',
      customerContactId: '8078ad47-a40e-4f69-bcbf-d80eca19d532',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:35:50+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:35:50.592+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'KK-Email-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_590b2027-468b-42bd-b817-d8d6e201fe42/case/201251645345',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35409,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645343',
      threadId: 'voice_8017155048_0d36eea8-1fbf-4ea4-b5c5-a40ae82c2b76',
      threadIdOnExternalPlatform: '201331660182',
      channelId: 'email_8017155048',
      interactionId: 'ea274d87-2d31-41d4-800c-125836b5d1f4',
      consumerContactStorageId:
        'voice_8017155048_0d36eea8-1fbf-4ea4-b5c5-a40ae82c2b76',
      contactId: 'c9554142-83c7-4b63-aa42-d473ce80034e',
      customerContactId: 'd068efbc-7d58-4d3f-8984-5cd5b67bb8c6',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:34:19+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:34:19.519+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook pages',
      skill: 'KK-Email-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_0d36eea8-1fbf-4ea4-b5c5-a40ae82c2b76/case/201251645343',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 1)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35500,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645342',
      threadId: 'voice_8017155048_06fd66f9-2f4a-459f-9304-afd206e8cfc8',
      threadIdOnExternalPlatform: '201331660159',
      channelId: 'email_8017155048',
      interactionId: 'e3204614-be7b-4360-b3ff-0148cc666a27',
      consumerContactStorageId:
        'voice_8017155048_06fd66f9-2f4a-459f-9304-afd206e8cfc8',
      contactId: '2a26f24e-7be5-4603-be42-18057ec2d3aa',
      customerContactId: 'f7841297-a411-4a9c-bd69-875f9ecfbe6f',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:32:50+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:32:50.732+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook',
      skill: 'KK-Email-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janus Doesne',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'Janus Doesne',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_06fd66f9-2f4a-459f-9304-afd206e8cfc8/case/201251645342',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 1)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35591,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645340',
      threadId: 'voice_8017155048_c43136b2-4d0d-474d-a9ab-5ddfd35d4826',
      threadIdOnExternalPlatform: '201331660143',
      channelId: 'voice_8017155048',
      interactionId: '9b3d2159-205f-454d-a4d8-7b3e393d6f5d',
      consumerContactStorageId:
        'voice_8017155048_c43136b2-4d0d-474d-a9ab-5ddfd35d4826',
      contactId: '1809d84b-37be-4859-8f94-ca05cf260cb1',
      customerContactId: '17614c55-91e9-44e8-9d0b-60d2da1e7478',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:31:17+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:31:17.705+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'John Smith',
      ownerAssigneeUser: 'John Smith',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_c43136b2-4d0d-474d-a9ab-5ddfd35d4826/case/201251645340',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35683,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645336',
      threadId: 'voice_8017155048_2ff84574-c4bc-4f98-ab07-9238fb0be0f2',
      threadIdOnExternalPlatform: '201331660118',
      channelId: 'email_8017155048',
      interactionId: 'e68928c1-4792-43cb-8f81-dac4dff93dbd',
      consumerContactStorageId:
        'voice_8017155048_2ff84574-c4bc-4f98-ab07-9238fb0be0f2',
      contactId: 'f9a58b20-6b6a-4ad5-baa0-9a385558c6b6',
      customerContactId: '732fb03c-79e5-4d89-8182-3deb24f3bd64',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:29:45+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:29:45.728+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'KK-Email-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'John Smith',
      ownerAssigneeUser: 'John Smith',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_2ff84574-c4bc-4f98-ab07-9238fb0be0f2/case/201251645336',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35773,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645332',
      threadId: 'voice_8017155048_790b2dcb-5d72-4a10-a6e2-f90d0253cde9',
      threadIdOnExternalPlatform: '201331660065',
      channelId: 'voice_8017155048',
      interactionId: '4aa3b199-666b-4df5-b5cc-fcf0b6cb2b41',
      consumerContactStorageId:
        'voice_8017155048_790b2dcb-5d72-4a10-a6e2-f90d0253cde9',
      contactId: '2e907d4f-a84c-482a-9b93-00d31c5d5f51',
      customerContactId: 'fe2b2879-4199-42f4-9e2e-c95b1bc4fa4e',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:25:44+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:25:44.410+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Kalby Awadkansee',
      ownerAssigneeUser: 'Kalby Awadkansee',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150006',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_790b2dcb-5d72-4a10-a6e2-f90d0253cde9/case/201251645332',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150006',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150006',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150006',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150006',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150006',
          },
        ],
        messageStatistics: {
          inbound: 398,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 398,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 35964,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645328',
      threadId: 'voice_8017155048_053e73b1-2a46-4b1c-a588-2fbb7232bcb2',
      threadIdOnExternalPlatform: '201331660016',
      channelId: 'voice_8017155048',
      interactionId: '27d01937-cf1d-45d9-b04c-28606dc4a21c',
      consumerContactStorageId:
        'voice_8017155048_053e73b1-2a46-4b1c-a588-2fbb7232bcb2',
      contactId: '0f87d6a1-93be-4ed3-8536-bbe8c56115bd',
      customerContactId: '3cac5f6b-c7f8-45fe-9ad0-0516c307aa42',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:24:59+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:24:59.429+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Kalby Awadkansee',
      ownerAssigneeUser: 'Kalby Awadkansee',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150005',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_053e73b1-2a46-4b1c-a588-2fbb7232bcb2/case/201251645328',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150005',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150005',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150005',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150005',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150005',
          },
        ],
        messageStatistics: {
          inbound: 416,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 416,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36073,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645325',
      threadId: 'voice_8017155048_56077a19-02ba-4eea-8574-ba813e8a63e8',
      threadIdOnExternalPlatform: '201331660001',
      channelId: 'voice_8017155048',
      interactionId: 'af7a2c17-77cc-4dff-86e9-152e7679ceb5',
      consumerContactStorageId:
        'voice_8017155048_56077a19-02ba-4eea-8574-ba813e8a63e8',
      contactId: '66ad0311-5d53-40bd-b2ef-e4452d61888e',
      customerContactId: '9903f3c0-d0e5-4a07-84ff-a0928ef0623c',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:23:11+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:23:11.367+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'John Smithson',
      ownerAssigneeUser: 'John Smithson',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150008',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_56077a19-02ba-4eea-8574-ba813e8a63e8/case/201251645325',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150008',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150008',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150008',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150008',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150008',
          },
        ],
        messageStatistics: {
          inbound: 570,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 570,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36180,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645323',
      threadId: 'voice_8017155048_7acb68f9-31e9-4812-a0ab-9acd3915769c',
      threadIdOnExternalPlatform: '201331659992',
      channelId: 'voice_8017155048',
      interactionId: 'c54b138d-5e65-472f-95ec-552f7abfadc7',
      consumerContactStorageId:
        'voice_8017155048_7acb68f9-31e9-4812-a0ab-9acd3915769c',
      contactId: 'da4b3886-def3-4f83-8e88-129f87486467',
      customerContactId: '06385cf8-aa50-458c-bc50-2bfedf1ed3a5',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:21:25+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:21:25.371+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'John Smithson',
      ownerAssigneeUser: 'John Smithson',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150010',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_7acb68f9-31e9-4812-a0ab-9acd3915769c/case/201251645323',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150010',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150010',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150010',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150010',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150010',
          },
        ],
        messageStatistics: {
          inbound: 190,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 190,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36223,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645320',
      threadId: 'voice_8017155048_bcf0bec7-4e73-4fc9-b440-9315ff5f0003',
      threadIdOnExternalPlatform: '201331659946',
      channelId: 'voice_8017155048',
      interactionId: '4d4f5454-af9d-4adb-8c17-c2e48e6e2fbc',
      consumerContactStorageId:
        'voice_8017155048_bcf0bec7-4e73-4fc9-b440-9315ff5f0003',
      contactId: '5a983d7b-2117-4c75-97ab-8deb811a5081',
      customerContactId: '8b2d18df-d9ab-4627-a9fd-ee81b6ccd6f4',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:19:13+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:19:13.465+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150009',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_bcf0bec7-4e73-4fc9-b440-9315ff5f0003/case/201251645320',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150009',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150009',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150009',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150009',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150009',
          },
        ],
        messageStatistics: {
          inbound: 484,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 484,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36418,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645319',
      threadId: 'voice_8017155048_1669bc33-b43b-488c-b9bb-7df7cf0b85b3',
      threadIdOnExternalPlatform: '201331659936',
      channelId: 'voice_8017155048',
      interactionId: '62e3a530-c016-4a20-809b-132bd7ee8aa0',
      consumerContactStorageId:
        'voice_8017155048_1669bc33-b43b-488c-b9bb-7df7cf0b85b3',
      contactId: 'fd019b62-058b-499d-8345-8c1a89ad481b',
      customerContactId: 'fae3974d-a21e-43b3-9d24-71a857112abe',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:17:22+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:17:22.336+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_1669bc33-b43b-488c-b9bb-7df7cf0b85b3/case/201251645319',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36457,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645318',
      threadId: 'voice_8017155048_f494e092-d485-4bd9-a0b8-d548f88edb0b',
      threadIdOnExternalPlatform: '201331659918',
      channelId: 'voice_8017155048',
      interactionId: '3c25ad9c-330a-445a-a25f-27a60e59f0de',
      consumerContactStorageId:
        'voice_8017155048_f494e092-d485-4bd9-a0b8-d548f88edb0b',
      contactId: '98ab1edf-9ae3-45b8-b2d9-2d3f6a3b0d9b',
      customerContactId: 'dc010f4f-135d-46af-a63b-46c787b9e206',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:16:49+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:16:49.379+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_f494e092-d485-4bd9-a0b8-d548f88edb0b/case/201251645318',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36536,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645317',
      threadId: 'voice_8017155048_a013b6c8-2eb8-4784-b8dd-045da68b344c',
      threadIdOnExternalPlatform: '201331659887',
      channelId: 'voice_8017155048',
      interactionId: '525cfada-81e0-4b8e-80eb-e16eb8b2fc2b',
      consumerContactStorageId:
        'voice_8017155048_a013b6c8-2eb8-4784-b8dd-045da68b344c',
      contactId: 'dcb0e3c7-3646-4c2c-b1de-1b0e27448b66',
      customerContactId: 'bd3b3b01-ea52-43e2-a3e0-544612b0e6a1',
      status: 'new',
      statusUpdatedAt: '2024-05-16T23:15:31+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:15:31.184+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'Facebook friend suggestions',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150005',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_a013b6c8-2eb8-4784-b8dd-045da68b344c/case/201251645317',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150005',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150005',
        fullName: 'Keshav Kishor',
      },
      direction: 'outbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150005',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150005',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150005',
          },
        ],
        messageStatistics: {
          inbound: 416,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 416,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36577,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645316',
      threadId: 'voice_8017155048_1aa5ac16-0a58-4c48-92a9-f4a1e207ae42',
      threadIdOnExternalPlatform: '201331659877',
      channelId: 'voice_8017155048',
      interactionId: '464b397b-fb09-45a2-9a9a-913fe5c85500',
      consumerContactStorageId:
        'voice_8017155048_1aa5ac16-0a58-4c48-92a9-f4a1e207ae42',
      contactId: '366a8ff8-3e36-410b-8da6-6754d675f582',
      customerContactId: 'b932f1a0-6141-4be7-ae7a-04b97add6380',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:14:47+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:14:47.927+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janwdye Shealty',
      ownerAssigneeUser: 'Janwdye Shealty',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_1aa5ac16-0a58-4c48-92a9-f4a1e207ae42/case/201251645316',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36619,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645315',
      threadId: 'voice_8017155048_34c1fc34-750c-4a29-97c0-1e57433c675a',
      threadIdOnExternalPlatform: '201331659860',
      channelId: 'voice_8017155048',
      interactionId: 'd7177590-4f70-47a2-80f7-8370046c7d96',
      consumerContactStorageId:
        'voice_8017155048_34c1fc34-750c-4a29-97c0-1e57433c675a',
      contactId: 'e4d60d34-2e9e-428b-a561-cd36d9576907',
      customerContactId: '3b419921-84f9-4679-a863-be4eca4438ac',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:14:06+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:14:06.196+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150006',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_34c1fc34-750c-4a29-97c0-1e57433c675a/case/201251645315',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150006',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150006',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150006',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150006',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150006',
          },
        ],
        messageStatistics: {
          inbound: 398,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 398,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36661,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645314',
      threadId: 'voice_8017155048_5ac15507-97c7-49ee-aed3-3754648074d2',
      threadIdOnExternalPlatform: '201331659849',
      channelId: 'voice_8017155048',
      interactionId: '26452722-fe30-4575-acf8-07d10b315c52',
      consumerContactStorageId:
        'voice_8017155048_5ac15507-97c7-49ee-aed3-3754648074d2',
      contactId: 'b28c7d2b-c7f4-4ebc-bfeb-e8a88748a43c',
      customerContactId: '8b44d6a2-82a1-4c5d-b52f-72a015a011a1',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:13:26+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:13:26.189+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150009',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_5ac15507-97c7-49ee-aed3-3754648074d2/case/201251645314',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150009',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150009',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150009',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150009',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150009',
          },
        ],
        messageStatistics: {
          inbound: 484,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 484,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36703,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645313',
      threadId: 'voice_8017155048_c738c40d-2159-4da9-8b5d-31c4d77d5a10',
      threadIdOnExternalPlatform: '201331659821',
      channelId: 'voice_8017155048',
      interactionId: 'acca6685-77b6-488a-bff6-42492b034192',
      consumerContactStorageId:
        'voice_8017155048_c738c40d-2159-4da9-8b5d-31c4d77d5a10',
      contactId: 'cea8e8d1-9d4d-45d4-9574-625a0941c7f5',
      customerContactId: 'e956cedf-8b07-4020-b7c5-31791b950c50',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:12:43+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:12:43.130+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150008',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_c738c40d-2159-4da9-8b5d-31c4d77d5a10/case/201251645313',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150008',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150008',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150008',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150008',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150008',
          },
        ],
        messageStatistics: {
          inbound: 570,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 570,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36808,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645312',
      threadId: 'voice_8017155048_64f7443e-196d-40e5-a0c8-d17f2a44a75c',
      threadIdOnExternalPlatform: '201331659811',
      channelId: 'voice_8017155048',
      interactionId: 'ec4ec79b-d3d1-47ea-b922-4567bd68d65b',
      consumerContactStorageId:
        'voice_8017155048_64f7443e-196d-40e5-a0c8-d17f2a44a75c',
      contactId: '96a312c5-cd44-4512-8df3-d549b6a086d1',
      customerContactId: '43120da3-b720-49ae-8115-9701bbcdb761',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:10:58+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:10:58.142+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janet Dolgera',
      ownerAssigneeUser: 'Janet Dolgera',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150002',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_64f7443e-196d-40e5-a0c8-d17f2a44a75c/case/201251645312',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150002',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150002',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150002',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [
          {
            ident: 'name',
            value: 'Chacha Choudhary',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mail_id',
            value: 'Kesu@kissore.com',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'city-name',
            value: 'm',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'state-name',
            value: 'Maharashtra',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
          {
            ident: 'mobile-number',
            value: '8692098479',
            updatedAt: '2024-02-12T05:36:33+00:00',
          },
        ],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150002',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150002',
          },
        ],
        messageStatistics: {
          inbound: 958,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 958,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36849,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645311',
      threadId: 'voice_8017155048_3be0041e-c4b5-444d-a85b-1607bd3c7130',
      threadIdOnExternalPlatform: '201331659795',
      channelId: 'voice_8017155048',
      interactionId: 'e17d733b-e359-4e5e-975c-8de4f5804d6a',
      consumerContactStorageId:
        'voice_8017155048_3be0041e-c4b5-444d-a85b-1607bd3c7130',
      contactId: '249685e8-d807-49ed-8567-141e0883d32c',
      customerContactId: '477191e4-3392-42e2-812d-bc1cffcf5f3a',
      status: 'closed',
      statusUpdatedAt: '2024-05-16T23:10:16+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:10:16.101+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'Usha-Routing-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: null,
      inboxAssigneeUser: 'Janus Doesne',
      ownerAssigneeUser: 'Janus Doesne',
      inboxPreAssigneeUser: null,
      ownerAssignee: null,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: '14005150008',
          name: 'Keshav Kishor',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/voice_8017155048_3be0041e-c4b5-444d-a85b-1607bd3c7130/case/201251645311',
      authorEndUserIdentity: {
        idOnExternalPlatform: '14005150008',
        firstName: 'Keshav',
        lastName: 'Kishor',
        nickname: 'Keshav Kishor',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'voice',
        id: 'voice_14005150008',
        fullName: 'Keshav Kishor',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'voice_14005150008',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Keshav',
        surname: 'Kishor',
        fullName: 'Keshav Kishor',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: '14005150008',
            firstName: 'Keshav',
            lastName: 'Kishor',
            nickname: 'Keshav Kishor',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'voice',
            id: 'voice_14005150008',
          },
        ],
        messageStatistics: {
          inbound: 570,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 570,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'NOT_ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 36890,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 0,
          label: '',
          exceeded: 0,
          percent: 0,
          treshold: 10000,
          isRunning: false,
          alreadyHasValue: true,
        },
      },
      preview: 'Voice conversation',
      isOutboundAllowed: false,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
    {
      id: '201251645308',
      threadId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
      threadIdOnExternalPlatform:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
      channelId: 'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee',
      interactionId: '79ca7c30-516b-4db2-b401-0328c6ad0941',
      consumerContactStorageId:
        'chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
      contactId: '5d5a9b16-cefa-453e-a1a4-7124329c56d0',
      customerContactId: '1373da6b-5d50-415b-8780-b5cef20f53cb',
      status: 'new',
      statusUpdatedAt: '2024-05-16T23:07:45+00:00',
      statusUpdatedAtWithMilliseconds: '2024-05-16T23:07:45.000+00:00',
      tags: [],
      routingQueueId: '11cd1eb8-5d55-464d-9c87-dd09ad6d41b4',
      author: 'SocialMe - You ask, We Instagram',
      skill: 'KK-Chat-Queue',
      routingQueuePriority: 0,
      inboxAssignee: null,
      inboxAssigneeLastAssignedAt: '2024-05-16T23:07:47+00:00',
      inboxAssigneeUser: 'John Smith',
      // ownerAssigneeUser: {
      //   id: 36858,
      //   incontactId: '11eec579-5ce9-1d40-add4-0242ac110005',
      //   agentId: 2570088,
      //   emailAddress: 'pranay.more@nice.com',
      //   loginUsername: 'cxagent01.cxiauigbu@so32.com',
      //   firstName: 'cxagent01',
      //   surname: 'cxiauigbu',
      //   nickname: '',
      //   imageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   publicImageUrl:
      //     'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user/c.png',
      //   isBotUser: false,
      //   isSurveyUser: false,
      // },
      ownerAssigneeUser: 'John Smith',
      inboxPreAssigneeUser: null,
      ownerAssignee: 36858,
      endUserRecipients: [],
      recipients: [
        {
          idOnExternalPlatform: 'b3acd671-3246-6cfd-7522-8bc1e7d14d35',
          name: 'Liam Davis',
          isPrimary: true,
          isPrivate: false,
          anonymizedAt: null,
          anonymizedReason: null,
        },
      ],
      detailUrl:
        'https://app-de-na1.staging.niceincontact.com/care?redirect=no#/care/tab/chat_8dadcab8-4d4b-4d8e-bd85-acba515bfcee_b3acd671-3246-6cfd-7522-8bc1e7d14d35/case/201251645308',
      authorEndUserIdentity: {
        idOnExternalPlatform: 'b3acd671-3246-6cfd-7522-8bc1e7d14d35',
        firstName: 'Liam',
        lastName: 'Davis',
        nickname: 'Liam Davis',
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        externalPlatformId: 'chat',
        id: 'chat_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
        fullName: 'Liam Davis',
      },
      direction: 'inbound',
      createdAt: new Date(
        new Date().setMonth(new Date().getMonth() - 3)
      ).toISOString(),
      inboxPreAssignee: null,
      customFields: [],
      userFingerprint: null,
      statistics: {
        inboxAssigneeResponseTime: null,
      },
      endUser: {
        id: 'chat_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
        updatedAt: new Date(
          new Date().setMonth(new Date().getMonth() - 3)
        ).toISOString(),
        firstName: 'Liam',
        surname: 'Davis',
        fullName: 'Liam Davis',
        customFields: [],
        image:
          'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
        identities: [
          {
            idOnExternalPlatform: 'b3acd671-3246-6cfd-7522-8bc1e7d14d35',
            firstName: 'Liam',
            lastName: 'Davis',
            nickname: 'Liam Davis',
            image:
              'https://assets-de-na1.staging.niceincontact.com/platform/static/public/img/user-default.png',
            externalPlatformId: 'chat',
            id: 'chat_b3acd671-3246-6cfd-7522-8bc1e7d14d35',
          },
        ],
        messageStatistics: {
          inbound: 2,
          outbound: 0,
        },
        sentimentStatistics: {
          positive: 0,
          neutral: 2,
          negative: 0,
        },
      },
      abandon: null,
      routableType: 'ROUTABLE',
      proficiency: {
        from: 1,
        to: 20,
      },
      sla: {
        firstResponseTime: {
          raw: 56819,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 3600,
          isRunning: true,
          alreadyHasValue: false,
        },
        solutionTime: {
          raw: 56819,
          label: '',
          exceeded: 1,
          percent: 100,
          treshold: 10000,
          isRunning: true,
          alreadyHasValue: false,
        },
      },
      preview: 'LOAD TEST MESSAGEb3acd671-3246-6cfd-7522...',
      isOutboundAllowed: true,
      customerStatistics: {
        unseenMessagesCount: 0,
      },
      userStatistics: {
        unseenMessagesCount: 1,
      },
    },
  ],
  scrollToken:
    'MjAyNC0wNS0xNlQyMzowNzo0NSswMDAwI2RhdGV0aW1lIzIwMjQtMDUtMTZUMjM6MDc6NDUrMDAwMCMyMDI0LTA1LTE2VDIzOjA3OjQ1KzAwMDAjMjAxMjUxNjQ1MzA4',
};
